module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/main_pc_f77ad67a697bf22fbeb818dc87fc2fa2.jpg";